import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "option1", "option2"]

  connect() {
    this.toggleOptions();
  }

  toggleOptions() {
    const value = this.parseValue();
    if (value) {
      this.addClassIfMissing(this.option1Target, "hidden");
      this.removeClassIfPresent(this.option2Target, "hidden");
    } else {
      this.removeClassIfPresent(this.option1Target, "hidden");
      this.addClassIfMissing(this.option2Target, "hidden");
    }
  }

  addClassIfMissing(target, klass) {
    if (!target.classList.contains(klass)) target.classList.add(klass);
  }

  removeClassIfPresent(target, klass) {
    if (target.classList.contains(klass)) target.classList.remove(klass);
  }

  parseValue() {
    if (this.sourceTarget.type === "checkbox") {
      return this.sourceTarget.checked;
    }
  }
}
